import {Component, Input, OnInit} from '@angular/core'
import {IonButton, IonIcon, IonLabel, ModalController, Platform} from '@ionic/angular/standalone'
import {Store} from '@ngrx/store'
import {BaseClassComponent} from '@common/base-class.component'
import {LogoutModalComponent} from '@common/components/logout-modal/logout-modal.component'
import {ID_ANDROID, ID_IOS} from '@common/global-constants'
import {environment} from '@environments/environment'
import {ModalDismissRole} from '@models/enums/modal'
import {VersionCheck} from '@models/version-check'
import {UveTranslatePipe} from '@pipes/uve-translate.pipe'
import {AuthService} from '@service/auth/auth.service'
import {MarketService} from '@service/market.service'
import {NetworkService} from '@service/network.service'
import {PermissionsService} from '@service/permissions/permissions.service'
import {VersionService} from '@service/version.service'
import {ModalHeaderComponent} from '../../modal-header/modal-header.component'

@Component({
  selector: 'app-modal-about-user',
  imports: [IonButton, IonIcon, IonLabel, ModalHeaderComponent, UveTranslatePipe],
  templateUrl: './modal-about-user.component.html',
  styleUrl: './modal-about-user.component.scss',
})
export class ModalAboutUserComponent extends BaseClassComponent implements OnInit {
  @Input() title = 'confirm'
  @Input() user: string
  @Input() version: string
  @Input() isImpersonate: boolean
  @Input() name: string
  @Input() surname: string
  isUpdateRequired: boolean
  isClicked = false

  constructor(
    private readonly modalController: ModalController,
    public networkService: NetworkService,
    public permissions: PermissionsService,
    public platform: Platform,
    protected store: Store,
    private readonly versionService: VersionService,
    private readonly authService: AuthService,
    private readonly marketService: MarketService
  ) {
    super(store, platform)
  }

  ngOnInit(): void {
    this.versionCheck()
  }

  redirectToStore = (): Promise<void> => this.marketService.openStore(this.platform.is('android') ? ID_ANDROID : ID_IOS)

  private readonly versionCheck = (): void => {
    this.versionService.checkVersion().then((updateVersion: VersionCheck): void => {
      this.isUpdateRequired = updateVersion.mandatory || updateVersion.update
    })
  }

  logout = async (): Promise<void> => {
    if (this.isClicked || !this.networkService.isOnline()) {
      return
    }

    this.isClicked = true

    setTimeout(() => {
      this.isClicked = false
    }, 2000)

    this.modalController.dismiss(null, ModalDismissRole.CANCELED)

    const conditionImpersonate = !this.isImpersonate || (this.isImpersonate && !environment.production)

    if (conditionImpersonate) {
      const modal = await this.modalController.create({
        component: LogoutModalComponent,
        cssClass: 'logout-modal',
        backdropDismiss: false,
      })
      await modal.present()
    } else {
      await this.authService.logout()
    }
  }

  close = (): Promise<boolean> => this.modalController.dismiss(null, ModalDismissRole.CANCELED)
}
